import {ThemeProvider} from '@mui/material/styles';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {SnackbarProvider} from 'notistack';
import * as ReactDOM from 'react-dom/client';
import {BrowserRouter as Router} from 'react-router-dom';
import App from './App';
import {theme} from './styles/theme';
import {MsalContextProvider} from '@/components/MSAL/MsalContextProvider';
import './main.css';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Router>
        <ThemeProvider theme={theme}>
            <MsalContextProvider>
                <SnackbarProvider>
                    <QueryClientProvider client={queryClient}>
                        <App/>
                        <ReactQueryDevtools initialIsOpen={false}/>
                    </QueryClientProvider>
                </SnackbarProvider>
            </MsalContextProvider>
        </ThemeProvider>
    </Router>
);
